var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCurrency24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_currency24x24",
    transform: "translate(-3.008 -4.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coin",
    transform: "translate(3.008 4.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24769",
    "data-name": "Group 24769",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45957",
    "data-name": "Path 45957",
    d: "M10.688,48.2l-.03-.043a.93.93,0,0,1,.082-1.14c.041-.047.085-.1.141-.156a1.085,1.085,0,0,1,1.539-.135c.371.269.741.553,1.094.824.07.051.137.105.208.156.052-.058.1-.12.159-.179q.55-.623,1.094-1.246a7.455,7.455,0,0,0-4.045-8.866,7.718,7.718,0,0,0-9.56,2.5,7.4,7.4,0,0,0,.97,9.669,7.74,7.74,0,0,0,9.872.614c-.408-.521-.823-1.046-1.228-1.567A5.044,5.044,0,0,1,10.688,48.2Zm-.85-1.061a2.463,2.463,0,0,1-1.276.8.357.357,0,0,0-.241.136.344.344,0,0,0-.067.265c.011.222,0,.444,0,.666a.273.273,0,0,1-.075.225.284.284,0,0,1-.225.085c-.241.007-.486.007-.73,0a.3.3,0,0,1-.235-.092.292.292,0,0,1-.08-.236c0-.16,0-.324,0-.485,0-.357-.015-.371-.367-.427a4.711,4.711,0,0,1-1.3-.365c-.322-.153-.356-.233-.263-.565.07-.248.137-.491.215-.739.089-.284.167-.32.434-.182a4.225,4.225,0,0,0,1.439.423,1.824,1.824,0,0,0,.946-.12.724.724,0,0,0,.475-.58.716.716,0,0,0-.3-.683,2.311,2.311,0,0,0-.537-.31,12.862,12.862,0,0,1-1.472-.649A2.039,2.039,0,0,1,5,42.35a2.159,2.159,0,0,1,1.6-2c.393-.143.393-.135.4-.54v-.408c.007-.306.059-.357.367-.365h.285c.656,0,.656,0,.66.645,0,.455,0,.459.463.528a4.1,4.1,0,0,1,1.02.295.3.3,0,0,1,.185.155.29.29,0,0,1,.008.239c-.082.277-.159.557-.248.834s-.171.295-.426.179A3.252,3.252,0,0,0,7.7,41.6a1.241,1.241,0,0,0-.43.087.6.6,0,0,0-.416.487.6.6,0,0,0,.264.58,2.973,2.973,0,0,0,.7.386,12.5,12.5,0,0,1,1.28.568A2.255,2.255,0,0,1,10.3,45.249a2.219,2.219,0,0,1-.462,1.888Z",
    transform: "translate(-.008 -36.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45958",
    "data-name": "Path 45958",
    d: "M308.356,258.883a.739.739,0,0,0-.411-.219c-.126,0-.237.1-.408.293q-1.29,1.5-2.58,2.987l-.586.675c-.1-.078-.193-.148-.285-.222-.508-.393-1.008-.789-1.52-1.171a.529.529,0,0,0-.3-.13.5.5,0,0,0-.341.2,1.479,1.479,0,0,0-.1.115.276.276,0,0,0-.03.352c.093.145.185.293.289.43q1.017,1.323,2.039,2.643a.355.355,0,0,0,.274.163.374.374,0,0,0,.3-.193q1.874-2.68,3.74-5.356C308.623,259.176,308.6,259.087,308.356,258.883Z",
    transform: "translate(-290.56 -250.717)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCurrency24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_currency24x24.2d0be302336d7cc1ff33c9f402b9bde2.svg";